import { CheckCircle2, AlertTriangle } from "lucide-react";

/** Renders a strengths/risks/highlights list with a gold or red tone icon. */
export function BulletList({ items, tone = "gold" }) {
  const iconColor = tone === "red" ? "text-market-sell" : "text-kira-gold";
  const Icon = tone === "red" ? AlertTriangle : CheckCircle2;
  return (
    <ul className="space-y-3">
      {items.map((h, i) => (
        <li key={`${h}-${i}`} className="flex items-start gap-3">
          <Icon className={`h-4 w-4 ${iconColor} shrink-0 mt-0.5`} />
          <span className="text-sm text-kira-textMuted leading-relaxed">{h}</span>
        </li>
      ))}
    </ul>
  );
}
